import React from 'react';
import SaasHeroIntegrationRail from './SaasHeroIntegrationRail';
import SaasHeroRoiFloat from './SaasHeroRoiFloat';
import SaasRetentionFloat from './SaasRetentionFloat';
import SaasHeroPhone from './SaasHeroPhone';

export default function SaasHeroVisual() {
  return (
    <div className="mx-auto w-full max-w-[min(100%,1040px)] py-4 sm:py-8 flex justify-center px-3 sm:px-6">
      <div className="flex flex-row items-stretch justify-center">
        <aside className="flex flex-col justify-between shrink-0 w-[272px] md:w-[292px] lg:w-[300px] pr-0 -mr-4 md:-mr-6 pointer-events-none z-20 py-3 md:py-5">
          <SaasHeroRoiFloat />
          <SaasHeroIntegrationRail />
        </aside>

        <div className="relative z-10 w-[min(100%,300px)] sm:w-[320px] md:w-[336px] lg:w-[352px] shrink-0 select-none mx-auto sm:mx-0">
          <SaasHeroPhone className="h-[668px] sm:h-[692px] md:h-[712px] lg:h-[732px] max-h-[min(88vh,780px)]" />
        </div>

        <aside className="flex flex-col justify-start shrink-0 w-[96px] md:w-[108px] pl-0 -ml-2 md:-ml-3 pointer-events-none z-20 pt-10 md:pt-12 lg:pt-14 translate-x-2 md:translate-x-3">
          <SaasRetentionFloat />
        </aside>
      </div>
    </div>
  );
}
